import { oddsKeyArray } from '../oddsKeyArray'
const initClassicGame = () => {
  const mainAndSup = {
    mainKey: 'classic_game_play',
    supKey: ''
  }
  const keyObj = {}
  let i = 6
  let index = 1

  do {
    keyObj[`SP:MATCH:${index}:BALL:${i}`] = mainAndSup
    if (i === 0 && index === 1) {
      i = 6
      index = 0
    } else {
      i--
    }
  } while (i >= 0)

  return keyObj
}

const initNonChosen = () => {
  const mainKey = 'select_without_target'
  const loop = [5, 6]
  const keyObj = {}

  for (const num of loop) {
    keyObj[`CHOOSE:${num}:MATCH:0`] = {
      mainKey,
      supKey: `select_without_target_${num}`
    }

    keyObj[`MATCH:SP:0:CHOOSE:${num}:0`] = {
      mainKey,
      supKey: `select_without_target_${num}_sp`
    }
  }

  return keyObj
}

const initGuessHeadAndTail = () => {
  const keyObj = {}
  const headKey = { mainKey: 'guess_head_num', supKey: 'guess_head_num' }
  const tailKey = { mainKey: 'guess_tail_num', supKey: 'guess_tail_num' }
  let groupKey = ''

  for (let i = 0; i <= 9; i++) {
    if (i <= 4) {
      groupKey = `AMOUNT:HEAD:${i}`
      keyObj[groupKey] = {
        ...headKey,
        groupKey
      }
    }

    groupKey = `AMOUNT:TAIL:${i}`

    keyObj[groupKey] = {
      ...tailKey,
      groupKey
    }
  }

  keyObj['AMOUNT:HEAD:TIE'] = {
    ...headKey,
    groupKey: 'AMOUNT:HEAD:TIE'
  }
  keyObj['AMOUNT:TAIL:TIE'] = {
    ...tailKey,
    groupKey: 'AMOUNT:TAIL:TIE'
  }

  return keyObj
}

const initTwoSide = () => {
  const mainKey = 'two_side_phase'
  let groupKey = ''
  let supKey = ''

  return oddsKeyArray.reduce((root, oddsKey) => {
    switch (true) {
      case oddsKey === 'OVER' || oddsKey === 'UNDER':
        groupKey = `DIGIT:AMOUNT:${oddsKey}`
        supKey = 'over_under_sum'
        root[groupKey] = {
          mainKey,
          supKey,
          groupKey
        }
        root['DIGIT:AMOUNT:TIE'] = {
          mainKey,
          supKey,
          groupKey: 'DIGIT:AMOUNT:TIE'
        }
        break
      case oddsKey === 'ODD' || oddsKey === 'EVEN':
        groupKey = `PARITY:AMOUNT:${oddsKey}`
        supKey = 'odd_even_sum'
        root[groupKey] = {
          mainKey,
          supKey,
          groupKey
        }
        root['PARITY:AMOUNT:TIE'] = {
          mainKey,
          supKey,
          groupKey: 'PARITY:AMOUNT:TIE'
        }
        break
    }
    return root
  }, {})
}

const initSPTwoSide = () => {
  const mainKey = 'sp_two_side_phase'

  return oddsKeyArray.reduce((root, oddsKey) => {
    const groupKey = `SP:${oddsKey}`
    const supKey = oddsKey === 'ODD' || oddsKey === 'EVEN'
      ? 'odd_even'
      : 'over_under'
    root[groupKey] = {
      mainKey,
      supKey,
      groupKey
    }

    return root
  }, {})
}

const initElement = () => {
  const elementArray = ['AMOUNT:SKY', 'AMOUNT:AIR', 'AMOUNT:WATER', 'AMOUNT:FIRE', 'AMOUNT:EARTH', 'AMOUNT:TIE']

  return elementArray.reduce((root, groupKey) => {
    root[groupKey] = {
      mainKey: 'element',
      supKey: 'element',
      groupKey
    }

    return root
  }, {})
}

export default {
  ...initClassicGame(),
  ...initNonChosen(),
  ...initGuessHeadAndTail(),
  ...initTwoSide(),
  ...initSPTwoSide(),
  ...initElement()
}
